export const termsAndConditions = {
  am: {
    title: "ውሎች እና ሁኔታዎች",
    lastUpdated: "መጨረሻ የተሻሻለው",
    sections: [
      {
        title: "ስምምነት",
        content: `በምርጥ ሰው ትሬዲንግ ሃላ/የተ/የግ/ማህ የደንበኝንት አጠቃቀም እና በሚለቀቁት አገልግሎቶች ላይ የሚከተሉት ውሎች እና ሁኔታዎች ተፈጻሚ ይሆናሉ። ይህን መተግበሪያ በመጠቀም እነዚህን ውሎች እና ሁኔታዎች እንዳነበቡ፣ እንደተረዱ እና እንደተቀበሏቸው ይቆጠራሉ።

ማመልከቻዎቹን እና በእሱ ላይ የተለቀቁትን የደንበኝነት ስምምነት ለመጠቀም ፖሊሲውን ፣ ሁኔታዎችን እና ሃላፊነትን ለእርስዎ ማሳወቅ አስፈላጊ ስለሆነ እባክዎ እነዚህን ውሎች እና አገልግሎቶች በጥንቃቄ አንብበው ይረዱ።`,
      },
      {
        title: "የስምምነቱ ዓላማ",
        content: `የዚህ ስምምነት አላማ ምርጥ ሰው ያቀረባቸውን አገልግሎት ደንበኞች በደንበኝነት ተመዝጋቢ የሚሆኑበትን ዌይብ ሳይት እና ሞባይል አፕ በመገልገል ከትርፍ ነጻ ለምናቀርበው አገልግሎት የሚጠቀሙበትን ውሎች እና ተግባሮችን ማስፈጸም ነው።`,
      },
      {
        title: "በምርጥ ሰው ትሬዲንግ ሃላ/የተ/የግ/ማህ ምርጥ ሰው ለደንበኞች የሚሰጣቸው ጠቅላላ አገልግሎቶች",
        content: `• ማንኛውንም መሰረታዊ አስፈላጊ ቁሶችን(ማቴሪያል) ከአምራቹ ወገን በመሰብሰብ እና ከውጭ የሚገቡ ምርቶችን በመረከብ ከትርፍ ነጻ ለደንበኞች እና ወኪሎቻቸው ማቅረብ፤

• ከሀገር ዉጭ የሚኖሩ ኢትዮጵያዊ(ዲያስፖራ) የጀመሩትን እና ሊጀምሩ ያሰቡትን ሁሉንም መሰረተ ልማት' ልምድ ያላቸውን ባለሙያወች የተለየ ስልጠና መመሪያ እና ስምምነት በማድረግ እንዲጠናቀቁ እና አገልግሎት እንዲሰጡ ማድረግ፤

• የካፌ የሆቴል የትራንስፖርት አገልግሎቶችን ከትርፍ ነጻ ለደንበኞች ማቅረብ፤

• ማንኛውንም የደንበኝነት አገልግሎት በሞባይል አፕሊኬሽን፡ ትዛዛትን እና ክፍያን በተመለከተ የግል እና የመንግስት ባንኮችን ኤቲየም እና ናሽናል መታወቂያን በመጠቀም እንዲሁም በቴሌብር ሱፐር አፕ በመገልገል ከጥሬ ገንዘብ አገልግሎት በመውጣት ሲስተማቲክ ማድረግ፤

• የመንግስትን ቫት፤ ግብር እና የመንግስት አገልግሎቶችን ኦላይን ሲስተም በእለቱ መክፈል፤ ወዘተ...`,
      },
      {
        title: "የምርጥ ሰው መብትና ግዴታ",
        content: `• ምርጥ ሰው የደንበኞችን ፍላጎት ለማርካት የተለያዩ አገልግሎቶችን ከትርፍ ነፃ ይሰጣል።

• ምርጥ ሰው የደንበኞችን አፕሊኬሽኖች እና አገልግሎቶች አጠቃቀም ላይ የመንደፍ፣ የማሻሻል፣ የመቆጣጠር እና አስፈላጊውን ሁሉ እርምጃ የመውሰድ መብት አለው።

• ምርጥ ሰው ፣ እነዚህን ውሎች እና ስምምነቶች በማንኛውም ጊዜ የመቀየር ፣ የማሻሻል መብቱ የተጠበቀ ነው። እንደዚህ አይነት ለውጦች በምርጥ ሰው ድረ-ገጽ እና በማህበራዊ ሚዲያ መድረኮች በኩል ይላካሉ፡ ይለቀቃሉ።`,
      },
      {
        title: "የደንበኞች መብት እና ግዴታ",
        content: `• ደንበኞች አፑን ከፕሌይ ስቶር ወይም አፕስቶር አውርደው አፑን በስልክ ቀፎ ወይም ታብሌታቸው ላይ መጫን ይችላሉ።

• ደንበኛው አገልግሎቱን ምርጥ ሰው ላዘጋጀው ተግባር እና ለተፈቀደለት ዓላማ ብቻ መጠቀም ይኖርበታል።

• ደንበኞች ከምርጥ ሰው የአገልግሎት ውል ወይም አግባብነት ካለው ህግ ጋር የሚቃረኑ ከሆነ፣ ምርጥ ሰው ቀጣይነት ባለው መልኩ መጠቀምን ሊከለክል ይችላል።

• ደንበኞች የይለፍ ቃል እና የደንበኞችን አገልግሎት ለማግኘት እንዲሁም የወከላቸውን ቤተሰቦችን የስራ ሂደት ለማስጀመር ለድርጂቱ የስራ ማስኬጃ መቶ (100) ዶላር የድርጅቱ የባንክ ሂሳብ ቁጥር በማስገባት ደረሰኙን ፎርሙ ላይ አታች ማድረግ እና ለሎች 5 ደንበኞችን የማሳወቅ እና የማግባባት ግዴታ አለበት።

• ደንበኞች የይለፍ ቃላቸውን እና የመለያ ዝርዝሮቻቸውን ለሌላ ለማንም ማጋራት የለባቸውም።

• ደንበኞች +251903202023/27 በመደወል፣ መልክት ወደ mirtsewethio@gmail.com በመላክ ወይም በኢንቦክስ መልእክት ወደ ምርጥ ሰው ማህበራዊ ሚዲያ መድረኮች በመላክ እና/ ለድርጅቱ ማቅረብ የፈለጉትን ማንኛቸውንም አስተያየት፤ ሀሳብ፤ ቅሬታ፤ ምክር እና የመሳሰሉትን ማቅረብ ይችላሉ።

• የምርጥ ሰው ደንበኞች ከድርጅቱ ተጠቃሚ መሆናቸውን እና ለመሆን በመፈለጋቸው ቀድመው ለድርጅቱ ኮል ሴንተር በመደወል እና በድርጅቱ ኢሜል በመላክ መወያየት እና መረጃ ማግኘት ይችላሉ።

• ደንበኞች በምርጥ ሰው ሞባይል አፕ ላይ የሚለቀቁትን ብዙ አስደሳች አገልግሎቶች ለመጠቅም፦ ቀናነት፤ መልካም አስተሳብ ሀገራዊ ፍቅር፤ መረዳዳት እና መግባባት መኖር ግዴታ ነው።`,
      },
      {
        title: "ግላዊነት",
        content: `• ምርጥ ሰው የደንበኞችን መረጃ፤ ሚስጥር እና ግላዊነት ይጠብቃል ያከብራል።

• ምርጥ ሰው የደንበኞችን መረጃ በመጠቀም ምርቶችን እና አገልግሎቶችን ለማቅረብ እና ለማሳደግ ማሻሻያ ይጠቀማል።`,
      },
      {
        title: "ማሻሻያዎች",
        content: `• ምርጥ ሰው እነዚህን ውሎች፤ ሁኔታወች እና ስምምነቶችን ከጊዜ ወደ ጊዜ የመጨመር ወይም የማሻሻል መብቱ የተጠበቀ ነው። ካልተሻሻለም በነበረበት የጸና ይሆናል።

• እነዚህ ውሎች፤ ስምምነቶች እና ተግባሮች የሚተዳደሩት በኢትዮጵያ ህግ ነው።

• እነዚህ ውሎች እና ስምምነቶች www.mirtsew.com ድረገጽ ይገኛሉ።`,
      },
    ],
  },
  en: {
    title: "Terms and Conditions",
    lastUpdated: "Last Updated",
    sections: [
      {
        title: "Agreement",
        content: `The following terms and conditions apply to the use of services provided by Mirt Sew Trading PLC. By using this application, you are deemed to have read, understood, and accepted these terms and conditions.

It is essential that you carefully read and understand these terms and services, as it is necessary to inform you of the policies, conditions, and responsibilities for using the applications and customer agreements released therein.`,
      },
      {
        title: "Purpose of the Agreement",
        content: `The purpose of this agreement is to enforce the terms and procedures by which customers use the website and mobile app to register as subscribers and utilize the non-profit services provided by Mirt Sew.`,
      },
      {
        title: "General Services Provided by Mirt Sew Trading PLC to Customers",
        content: `• Collecting and providing essential basic materials from manufacturers and receiving imported products to customers and their agents free of charge;

• Providing specialized training, guidance, and agreements with experienced professionals for all infrastructure projects started or planned by Ethiopians living abroad (diaspora), ensuring completion and service delivery;

• Providing café, hotel, and transportation services to customers free of charge;

• Systematizing any customer service through mobile applications: using private and government banks (Ethio Telecom and National ID) for orders and payments, as well as utilizing Telebirr Super App to move away from cash services;

• Paying government VAT, taxes, and government services through online systems daily; etc.`,
      },
      {
        title: "Rights and Obligations of Mirt Sew",
        content: `• Mirt Sew provides various services free of charge to satisfy customer needs.

• Mirt Sew has the right to design, improve, control, and take all necessary measures regarding the use of customer applications and services.

• Mirt Sew reserves the right to change and modify these terms and agreements at any time. Such changes will be communicated and released through Mirt Sew's website and social media platforms.`,
      },
      {
        title: "Customer Rights and Obligations",
        content: `• Customers can download the app from the Play Store or App Store and install it on their mobile phones or tablets.

• Customers must use the service only for the purpose and authorized use for which Mirt Sew has designed it.

• If customers violate Mirt Sew's service agreement or applicable law, Mirt Sew may prohibit continued use.

• Customers are obligated to obtain a password and customer service, as well as to initiate the work process of their representative families, by depositing one hundred (100) dollars as operational capital into the company's bank account, attaching the receipt to the form, and notifying and communicating with 5 other customers.

• Customers must not share their passwords and account details with anyone else.

• Customers can submit any comments, ideas, complaints, advice, and the like by calling +251903202023/27, sending a message to mirtsewethio@gmail.com, or sending an inbox message to Mirt Sew's social media platforms.

• Mirt Sew customers can discuss and obtain information by calling the company's call center and sending emails to the company in advance regarding their use and desire to benefit from the company.

• To use the many exciting services released on the Mirt Sew mobile app, customers are obligated to have: honesty, good thinking, patriotism, mutual understanding, and communication.`,
      },
      {
        title: "Privacy",
        content: `• Mirt Sew protects and respects customer information, confidentiality, and privacy.

• Mirt Sew uses customer information to provide and improve products and services.`,
      },
      {
        title: "Amendments",
        content: `• Mirt Sew reserves the right to add or modify these terms, conditions, and agreements from time to time. If not modified, they shall remain as they are.

• These terms, agreements, and practices are governed by Ethiopian law.

• These terms and agreements are available at www.mirtsew.com.`,
      },
    ],
  },
};
